import { OnlyViewHoc } from 'hocs'

import { useStores } from 'hooks/useStores'
import { logisticFilialsApi } from 'redux/services/logistic-filial'

import { AppLoader } from 'components/AppLoader'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import { LogisticFilial, LogisticFilialStatus } from 'models/logistic-filial'
import { UserRole } from 'models/user'

import { LabledInfo, StatusHistory } from 'shared/ui'

import styles from './Details.module.scss'
import { EditLogisticModal } from './Edit'
import { UpdateStatus } from './UpdateStatus'

interface DetailsProps {
  id: LogisticFilial['id']
  onClose: () => void
}

export const Details = ({ id, onClose }: DetailsProps) => {
  const { userStore } = useStores()
  const role = userStore.user?.role as UserRole
  const { data, isLoading, isSuccess, error } =
    logisticFilialsApi.useGetLogisticFilialByIdQuery(id)

  if (isLoading) return <AppLoader />

  if (isSuccess) {
    const statuses = []

    if (role === UserRole.ControllerUKC) {
      if (data.status === LogisticFilialStatus.waiting) {
        statuses.push(LogisticFilialStatus.in_process)
      }
      if (data.status === LogisticFilialStatus.in_process) {
        statuses.push(LogisticFilialStatus.accepted)
        statuses.push(LogisticFilialStatus.denied)
      }
      if (data.status === LogisticFilialStatus.accepted) {
        statuses.push(LogisticFilialStatus.for_delivery)
        statuses.push(LogisticFilialStatus.denied)
      }
      if (data.status === LogisticFilialStatus.for_delivery) {
        statuses.push(LogisticFilialStatus.given)
        statuses.push(LogisticFilialStatus.no_accepted)
      }
    }

    return (
      <>
        <AppModalHeader onClose={onClose} title={`№${id}`} />
        <div className={styles.container}>
          <LabledInfo label="ФИО клиента">{data.client_full_name}</LabledInfo>
          <LabledInfo label="Пан">{data.pan}</LabledInfo>
          <LabledInfo label="Комментарий">{data.comment || '-'}</LabledInfo>
          <LabledInfo label="Дата создания">{data.created_at}</LabledInfo>
          <LabledInfo label="Дата эмбоссирования">
            {data.date_embossment}
          </LabledInfo>
          <LabledInfo label="Степень срочности">
            {data.degree_urgency_title}
          </LabledInfo>
          <LabledInfo label="Номер">{data.phone}</LabledInfo>
          <LabledInfo label="Тип">{data.cart_type_title}</LabledInfo>
          <LabledInfo label="Статус">{data.status_title}</LabledInfo>

          {data.branch && (
            <LabledInfo label="Филиал/СК">{data.branch.name}</LabledInfo>
          )}
          {data.specialist && (
            <LabledInfo label="Специалист">
              {data.specialist.full_name} {data.specialist.phone}
            </LabledInfo>
          )}

          <StatusHistory list={data.status_list} />

          <OnlyViewHoc>
            {data ? (
              <>
                {[LogisticFilialStatus.waiting].includes(data.status) &&
                  [UserRole.Specialist].includes(role) && (
                    <EditLogisticModal key={data.id} data={data} />
                  )}
                {statuses.map((status, idx) => (
                  <UpdateStatus status={status} id={id} key={idx + status} />
                ))}
              </>
            ) : null}
          </OnlyViewHoc>
        </div>
      </>
    )
  }

  return <code>{JSON.stringify(error)}</code>
}
